
























































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";

import NavigationTabs from "@/components/Settings/Venue/NavigationTabs.vue";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import Multiselect from "vue-multiselect";
import swal from "sweetalert";
import {
  EventPriceForm,
  IFacility,
  IVat,
  IVenue,
  IVenuePrice
} from "@/interface";
import { AxiosResponse } from "axios";

interface IWeekDay {
  id: number;
  name: string;
  checked: boolean;
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    Multiselect,
    Error404
  }
})
export default class VenuePrice extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "name",
    "description",
    "form",
    "vat_id",
    "amount",
    "venue_ids_to_attach"
  ];
  private noDataExist = false;
  private availableVats: Array<IVat> | null = null;
  private facilities: Array<IFacility> = [];
  private venueOptions: Array<IVenue> = [];
  private selectedVenue: IVenue = {
    name: null
  };
  private selectedVenueId: string | null = null;
  private selectedVenuePriceId: string | null = null;
  private selectedVenuePrice: IVenuePrice = {
    type: "default",
    name: null,
    description: null,
    form: EventPriceForm.GROSS,
    amount: 0,
    vat_id: 1,
    usable_online: false,
    venue_ids_to_attach: [],
    public_holiday: false
  };
  private attachedVenues: Array<IVenue> = [];
  private weekdays: Array<IWeekDay> = [
    {
      id: 0,
      name: "Monday",
      checked: false
    },
    {
      id: 1,
      name: "Tuesday",
      checked: false
    },
    {
      id: 2,
      name: "Wednesday",
      checked: false
    },
    {
      id: 3,
      name: "Thursday",
      checked: false
    },
    {
      id: 4,
      name: "Friday",
      checked: false
    },
    {
      id: 5,
      name: "Saturday",
      checked: false
    },
    {
      id: 6,
      name: "Sunday",
      checked: false
    }
  ];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedVenueId = vm.$route.params.id;
      vm.selectedVenuePriceId = vm.$route.params.price_id;
      if (vm.$route.params.price_type) {
        vm.selectedVenuePrice.type = vm.$route.params.price_type;
      }
      // Get Facilities
      vm.getFacilities(() => {
        //
      });

      // Get Venue
      if (
        typeof vm.selectedVenueId !== "undefined" &&
        vm.selectedVenueId !== null
      ) {
        vm.getVenue();
      }

      // Get Secondary Price
      if (
        typeof vm.selectedVenuePriceId !== "undefined" &&
        vm.selectedVenuePriceId !== null
      ) {
        if (vm.$route.query.venue_price_created) {
          swal("Success!", "The price was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getVenuePrice();
      }
      // Get Available vats
      vm.getVats();
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    // Get Facilities
    this.getFacilities(() => {
      //
    });

    // Get Venue
    if (
      typeof this.selectedVenueId !== "undefined" &&
      this.selectedVenueId !== null
    ) {
      this.getVenue();
    }

    // Get Secondary Price
    if (
      typeof this.selectedVenuePriceId !== "undefined" &&
      this.selectedVenuePriceId !== null
    ) {
      this.getVenuePrice();
    }
    // Get Available vats
    this.getVats();
    next();
  }

  private attachVenue(venue: IVenue): void {
    this.attachedVenues.push(venue);
  }

  private toggleCheckbox(id: number): void {
    this.weekdays[id].checked = !this.weekdays[id].checked;
  }

  private getFacilities(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.facilities = response.data.data;
        if (!this.selectedVenueId || this.selectedVenueId === "default") {
          const selectedFacility = this.facilities.find(
            (facility: IFacility) =>
              facility.venues && facility.venues.length > 0
          );
          if (
            selectedFacility &&
            selectedFacility.venues &&
            selectedFacility.venues[0].id
          ) {
            this.selectedVenueId = `${selectedFacility.venues[0].id}`;
          }
        }
        this.facilities.map((facility: IFacility) => {
          if (facility.venues) {
            facility.venues.map(venue => {
              this.venueOptions.push(venue);
            });
          }
        });
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private createOrUpdatePrice(): void {
    if (this.selectedVenuePriceId == null) {
      this.createVenuePrice();
    } else {
      this.updateVenuePrice();
    }
  }

  private getVenue(): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedVenue = response.data.data;
        if (!this.selectedVenuePriceId) {
          this.attachedVenues.push(this.selectedVenue);
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getVenuePrice(): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "venue-prices/" + this.selectedVenuePriceId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedVenuePrice.amount =
          response.data.data.form === "net"
            ? response.data.data.amount_net
            : response.data.data.amount_gross;
        this.selectedVenuePrice.vat_id = response.data.data.vat.id;
        this.selectedVenuePrice.type = response.data.data.type;
        this.selectedVenuePrice.name = response.data.data.name;
        this.selectedVenuePrice.form = response.data.data.form;
        this.selectedVenuePrice.usable_online =
          response.data.data.usable_online;
        this.selectedVenuePrice.description = response.data.data.description;
        this.attachedVenues = response.data.data.venues;
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateVenuePrice(): void {
    this.resetErrors();
    this.updating = true;
    const endpoint = this.$partnerEndpoint(
      "venue-prices/" + this.selectedVenuePriceId
    );
    this.selectedVenuePrice.venue_ids_to_attach = this.attachedVenues.map(
      (venue: IVenue) => venue.id as number
    );

    Api()
      .put(endpoint, this.selectedVenuePrice)
      .then((response: AxiosResponse) => {
        this.selectedVenuePriceId = response.data.data.id;
        this.getVenuePrice();
      })
      .catch((error: any) => {
        console.log(error);
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private createVenuePrice(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("venue-prices");
    this.selectedVenuePrice.venue_ids_to_attach = this.attachedVenues.map(
      (venue: IVenue) => venue.id as number
    );

    Api()
      .post(endpoint, this.selectedVenuePrice)
      .then((response: AxiosResponse) => {
        this.selectedVenuePriceId = response.data.data.id;
        this.$router.push({
          name: "VenuePriceDetails",
          params: {
            id: `${this.selectedVenueId}`,
            price_id: `${this.selectedVenuePriceId}`
          },
          query: { venue_price_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteVenuePrice(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The price will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "venue-prices/" + this.selectedVenuePriceId
        );

        Api()
          .delete(endpoint)
          .then((response: AxiosResponse) => {
            console.log(response.status);
            this.$router.push({
              name: "VenuePrices",
              query: { venue_price_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete venue prices.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getVats(): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("vats");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.availableVats = response.data.data;
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get venueName(): string {
    return (this.selectedVenue !== null && this.selectedVenue.name) || "";
  }
}
